import SettingsProvider from "../../services/settingsService/SettingsProvider";

export interface IManningOnlineTourState {
    hasSeenIntroStartModal: boolean;
    hasSeenIntroSteps: boolean;
    hasSeenIntroEndModal: boolean;
    hasSeenDesktopTour: boolean;
    hasSeenChatTour: boolean;
    hasSeenScrapbookTour: boolean;
    hasSeenMapTour: boolean;
    
    shouldShowDesktopTour: boolean;
}

class ManningOnlineTourClass {
    public getTourState(): Promise<IManningOnlineTourState> {
        return new Promise<IManningOnlineTourState>((resolve, reject) => {
            const defaultTourState: IManningOnlineTourState = {
                hasSeenChatTour: false,
                hasSeenDesktopTour: false,
                hasSeenIntroEndModal: false,
                hasSeenIntroStartModal: false,
                hasSeenIntroSteps: false,
                hasSeenMapTour: false,
                hasSeenScrapbookTour: false,
                shouldShowDesktopTour: false
            };

            SettingsProvider.fetchSettings().then(() => {
                const seralizedTour = SettingsProvider.get("manning-online-tour-state");
                if(!seralizedTour){ 
                    resolve(defaultTourState);
                    return; 
                }
    
                try {
                    const value = JSON.parse(seralizedTour);
                    if(typeof value == "object"){
                        resolve(value);
                    }
                    else {
                        resolve(defaultTourState);
                    }
                }
                catch(e){
                    resolve(defaultTourState);
                }
            });
        })
    }

    public storeTourState(tour: IManningOnlineTourState){
        SettingsProvider.set("manning-online-tour-state", JSON.stringify(tour));
    }
}

export const ManningOnlineTour = new ManningOnlineTourClass();